import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Modal, Button } from "react-bootstrap";
import { FaPlus, FaEdit, FaTrash, FaSortAmountUp, FaSortAmountDown, FaClipboardList, FaEye, FaTimesCircle, FaQuoteLeft } from "react-icons/fa";
import axios from "axios";
import useAuth from "../dashboard/useAuth";
import Sidebar from "../dashboard/sidebar";
import Navbar from "../dashboard/navbar";

const Liste_remboursement = ({ titre }) => {
    useAuth();
    const [achats, setAchats] = useState([]);
    const [selectedAchat, setSelectedAchat] = useState(null);
    const [sortConfig, setSortConfig] = useState({ key: "date_achat", direction: "descending" });
    const [searchTerm, setSearchTerm] = useState("");
    const [filtreStatut, setFiltreStatut] = useState("tous");
    const [alert, setAlert] = useState({ message: "", type: "" });
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [showRemboursementModal, setShowRemboursementModal] = useState(false);
    const [motifRemboursement, setMotifRemboursement] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [accesGroupe, setAccesGroupe] = useState([]);
    const [showCommentModal, setShowCommentModal] = useState(false);
    const [selectedComment, setSelectedComment] = useState("");
    const user_id = localStorage.getItem("IDDDD");

    useEffect(() => {
        if (user_id) {
            document.title = "PayMe | Mes demandes de remboursement";
            verifGroupe();
            fetchAchats();
        }
    }, [user_id]);

    const fetchAchats = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_HOTE}/liste-remboursements-client/${user_id}/`);
            console.log("Données reçues:", response.data);

            // Vérification que la réponse a bien la structure attendue
            if (response.data && response.data.status === 'success' && Array.isArray(response.data.achats)) {
                setAchats(response.data.achats);
            } else {
                console.error("Structure de données inattendue:", response.data);
                setAchats([]);
                showAlert("Format de données incorrect", "danger");
            }
        } catch (error) {
            console.error("Erreur réseau:", error);
            setAchats([]);
            showAlert("Erreur lors du chargement des achats", "danger");
        }
    };

    const verifGroupe = async () => {
        const groupe = localStorage.getItem("groupe");
        try {
            const response = await axios.get(`${process.env.REACT_APP_HOTE}/verif-groupe/${user_id}/${groupe}`);
            if (response.status === 200) {
                const cleanedAccessArray = response.data.acces
                    .map(item => item.acces ? item.acces.replace(/[\[\]']/g, "").trim().split(",").map(access => access.trim()) : [])
                    .flat();
                setAccesGroupe(cleanedAccessArray);
                localStorage.setItem("accesGroupe", JSON.stringify(cleanedAccessArray));
            }
        } catch (error) {
            console.error('Erreur lors de la vérification du groupe', error);
        }
    };

    // if (!accesGroupe.includes("Produits")) {
    //     return null;
    // }

    const handleDeleteAchat = async () => {
        if (selectedAchat) {
            try {
                await axios.delete(`${process.env.REACT_APP_HOTE}/supprimer-achat/${selectedAchat.achat_id}/`);
                showAlert("Achat supprimé avec succès !");
                fetchAchats();
            } catch (error) {
                console.error("Erreur lors de la suppression", error);
                showAlert("Erreur lors de la suppression", "danger");
            } finally {
                setShowDeleteModal(false);
            }
        }
    };

    const showAlert = (message, type = "success") => {
        setAlert({ message, type });
        setTimeout(() => setAlert({ message: "", type: "" }), 3000);
    };

    const handleSort = (key) => {
        setSortConfig({
            key,
            direction: sortConfig.key === key && sortConfig.direction === "ascending" ? "descending" : "ascending"
        });
    };

    const filteredAchats = achats.filter(achat => {
        const matchesSearch =
            achat.nom_utilisateur.toLowerCase().includes(searchTerm.toLowerCase()) ||
            achat.nom_produit.toLowerCase().includes(searchTerm.toLowerCase()) ||
            achat.transaction_id.toLowerCase().includes(searchTerm.toLowerCase());

        const matchesStatus = filtreStatut === "tous" || achat.status === filtreStatut;

        return matchesSearch && matchesStatus;
    });

    const sortedAchats = [...filteredAchats].sort((a, b) => {
        if (a[sortConfig.key] < b[sortConfig.key]) return sortConfig.direction === "ascending" ? -1 : 1;
        if (a[sortConfig.key] > b[sortConfig.key]) return sortConfig.direction === "ascending" ? 1 : -1;
        return 0;
    });

    const indexOfLastAchat = currentPage * itemsPerPage;
    const indexOfFirstAchat = indexOfLastAchat - itemsPerPage;
    const currentAchats = sortedAchats.slice(indexOfFirstAchat, indexOfLastAchat);
    const totalPages = Math.ceil(sortedAchats.length / itemsPerPage);

    const formatCurrency = (amount) => {
        return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'XOF' }).format(amount);
    };

    const handleSubmitRemboursement = async () => {
        if (!selectedAchat || !motifRemboursement) {
            showAlert("Veuillez sélectionner un achat et indiquer un motif", "danger");
            return;
        }

        try {
            const response = await axios.put(
                `${process.env.REACT_APP_HOTE}/soumettre-demande-remboursement/${selectedAchat.achat_id}/`,
                {
                    motif: motifRemboursement,
                    statut: "En traitement" // Mettre à jour le statut
                }
            );

            if (response.data.status === 'success') {
                showAlert("Demande de remboursement envoyée avec succès!");
                setShowRemboursementModal(false);
                setMotifRemboursement("");
                fetchAchats(); // Rafraîchir la liste des achats
            } else {
                showAlert(response.data.message || "Erreur lors de la demande", "danger");
            }
        } catch (error) {
            console.error("Erreur lors de la demande", error);
            showAlert("Erreur lors de la demande de remboursement", "danger");
        }
    };

    return (
        <div id="wrapper">
            <Sidebar user_id={user_id} titre={titre} />
            <div id="page-wrapper" className="gray-bg">
                <Navbar />
                <div className="row wrapper border-bottom white-bg page-heading">
                    <div className="col-lg-12">
                        <h2 className="d-flex align-items-center">
                            <FaClipboardList size={25} className="mr-2" /> Mes demandes de remboursement
                        </h2>
                        <small>Suivi des remboursements.</small>
                    </div>
                </div>

                <div className="mt-4">
                    <div className="d-flex flex-column flex-md-row justify-content-between align-items-center mb-2">
                        <h5>Liste des demandes</h5>
                        <div className="d-flex flex-column flex-sm-row flex-wrap mt-3 mt-md-0" style={{ gap: "10px" }}>
                            <div className="d-flex">
                                {/* <button
                                    className="btn btn-success mr-2"
                                    onClick={() => {
                                        if (!selectedAchat) {
                                            showAlert("Veuillez sélectionner un achat", "warning");
                                        } else {
                                            setShowRemboursementModal(true);
                                        }
                                    }}
                                >
                                    <FaPlus /> Demander un remboursement
                                </button>
                                <button className="btn btn-success mr-2">
                                    <FaPlus /> Exporter
                                </button> */}
                            </div>
                        </div>
                    </div>

                    {alert.message && (
                        <div className={`alert alert-${alert.type}`}>{alert.message}</div>
                    )}

                    <div className="row">
                        <div className="col-lg-12">
                            <div className="ibox">
                                <div className="ibox-content">
                                    <div className="d-flex justify-content-between align-items-center mb-3" style={{ gap: "10px" }}>
                                        <div className="d-flex align-items-center" style={{ gap: "10px" }}>
                                            <select
                                                className="form-select bg-default p-1"
                                                style={{
                                                    width: "auto",
                                                    border: "1px black solid",
                                                    borderRadius: "5px",
                                                }}
                                                value={itemsPerPage}
                                                onChange={(e) => {
                                                    setItemsPerPage(Number(e.target.value));
                                                    setCurrentPage(1);
                                                }}
                                            >
                                                <option value={10}>10</option>
                                                <option value={20}>20</option>
                                                <option value={50}>50</option>
                                            </select>

                                            {/* <select
                                                className="form-select bg-default p-1"
                                                style={{
                                                    width: "auto",
                                                    border: "1px black solid",
                                                    borderRadius: "5px",
                                                }}
                                                value={filtreStatut}
                                                onChange={(e) => setFiltreStatut(e.target.value)}
                                            >
                                                <option value="tous">Tous les statuts</option>
                                                <option value="Terminé">Terminé</option>
                                                <option value="Échoué">Échoué</option>
                                                <option value="En attente">En attente</option>
                                            </select> */}
                                        </div>

                                        <input
                                            type="text"
                                            placeholder="Rechercher..."
                                            className="form-control"
                                            style={{ maxWidth: "150px", width: "100%" }}
                                            value={searchTerm}
                                            onChange={(e) => setSearchTerm(e.target.value)}
                                        />
                                    </div>

                                    <div className="table-responsive">
                                        <table
                                            className="footable table table-stripped footable-loaded tablet breakpoint"
                                            data-page-size="8"
                                            data-filter="#filter"
                                            style={{ fontSize: "12px" }}
                                        >
                                            <thead>

                                                <tr>
                                                    <th
                                                        className="text-secondary text-wrap  d-none d-md-table-cell"
                                                        onClick={() => handleSort("date_demande")}
                                                        style={{ width: "13%", minWidth: "100px" }}
                                                    >
                                                        Date demande
                                                        {sortConfig.key === "date_demande"} {sortConfig.direction === "ascending" ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                    </th>


                                                    <th
                                                        className="text-secondary text-wrap d-none d-md-table-cell  align-middle"
                                                        onClick={() => handleSort("nom_produit")}
                                                        style={{ width: "12%", minWidth: "80px" }}
                                                    >
                                                        Produit
                                                        {sortConfig.key === "nom_produit"} {sortConfig.direction === "ascending" ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                    </th>
                                                    <th
                                                        className="text-secondary text-wrap d-none d-md-table-cell text-center align-middle"
                                                        onClick={() => handleSort("quantite")}
                                                        style={{ width: "10%", minWidth: "70px" }}
                                                    >
                                                        Quantité
                                                        {sortConfig.key === "quantite"} {sortConfig.direction === "ascending" ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                    </th>
                                                    <th
                                                        className="text-secondary text-wrap d-none d-md-table-cell text-center align-middle"
                                                        onClick={() => handleSort("total")}
                                                        style={{ width: "12%", minWidth: "80px" }}
                                                    >
                                                        Montant
                                                        {sortConfig.key === "total"} {sortConfig.direction === "ascending" ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                    </th>
                                                    {/* <th
                                                        className="text-secondary text-wrap d-none d-md-table-cell text-center align-middle"
                                                        onClick={() => handleSort("mode_paiement")}
                                                        style={{ width: "15%", minWidth: "100px" }}
                                                    >
                                                        Paiement
                                                        {sortConfig.key === "mode_paiement"} {sortConfig.direction === "ascending" ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                    </th> */}
                                                    <th
                                                        className="text-secondary text-wrap d-none d-md-table-cell  align-middle"
                                                        onClick={() => handleSort("nom_vendeur")}
                                                        style={{ width: "12%", minWidth: "150px" }}
                                                    >
                                                        Vendeur
                                                        {sortConfig.key === "nom_vendeur"} {sortConfig.direction === "ascending" ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                    </th>
                                                    <th
                                                        className="text-secondary text-wrap d-none d-md-table-cell"
                                                        onClick={() => handleSort("transaction_id")}
                                                        style={{ width: "10%", minWidth: "100px" }}
                                                    >
                                                        Transaction
                                                        {sortConfig.key === "transaction_id"} {sortConfig.direction === "ascending" ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                    </th>
                                                    <th
                                                        className="text-secondary text-wrap  d-none d-md-table-cell"
                                                        onClick={() => handleSort("date_traitement")}
                                                        style={{ width: "13%", minWidth: "100px" }}
                                                    >
                                                        Date traitement
                                                        {sortConfig.key === "date_traitement"} {sortConfig.direction === "ascending" ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                    </th>
                                                    <th
                                                        className="text-secondary text-wrap text-center d-none d-md-table-cell"
                                                        onClick={() => handleSort("statut")}
                                                        style={{ width: "10%", minWidth: "100px" }}
                                                    >
                                                        Statut
                                                        {sortConfig.key === "statut"} {sortConfig.direction === "ascending" ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                    </th>
                                                    <th
                                                        className="text-secondary text-wrap text-center"
                                                        style={{ width: "5%", minWidth: "50px" }}
                                                    >
                                                        
                                                    </th>

                                                    {/* <th
                                                        className="text-secondary text-wrap d-none d-md-table-cell text-center align-middle"
                                                        onClick={() => handleSort("status")}
                                                        style={{ width: "10%", minWidth: "80px" }}
                                                    >
                                                        Statut
                                                        {sortConfig.key === "status"}{sortConfig.direction === "ascending" ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                    </th> */}
                                                </tr>
                                            </thead>
                                            <tbody>
  {currentAchats && currentAchats.length > 0 ? (
    currentAchats.map((achat) => (
      <tr
        key={achat.achat_id}
        // onClick={() => setSelectedAchat(achat)}
        // className={`bg-white ${selectedAchat?.achat_id === achat.achat_id ? "bg-success text-white" : ""}`}
      >
        <td
          className="d-none d-md-table-cell align-middle"
          style={{ padding: "0.5rem" }}
        >
          <span>{achat.date_demande}</span>
        </td>
        <td
          className="align-middle"
          style={{ padding: "0.5rem" }}
        >
          <span className="text-dark">{achat.nom_produit}</span>
        </td>
        <td
          className="d-none d-md-table-cell text-center align-middle"
          style={{ padding: "0.5rem" }}
        >
          <span className="fw-semibold">{achat.quantite}</span>
        </td>
        <td
          className="d-none d-md-table-cell text-center align-middle"
          style={{ padding: "0.5rem" }}
        >
          <span className="fw-semibold">{formatCurrency(achat.total)}</span>
        </td>
        <td
          className="align-middle"
          style={{ padding: "0.5rem" }}
        >
          <div className="fw-semibold">{achat.nom_vendeur}</div>
        </td>
        <td
          className="align-middle"
          style={{ padding: "0.5rem" }}
        >
          <div className="fw-semibold">{achat.transaction_id}</div>
        </td>
        <td
          className="d-none d-md-table-cell align-middle"
          style={{ padding: "0.5rem" }}
        >
          <span>{achat.date_traitement}</span>
        </td>
        <td
          className="text-center align-middle"
          style={{ padding: "0.5rem" }}
        >
          <div
            className={`badge fw-semibold ${
              achat.statut === "Acheté"
                ? "bg-success text-white"
                : achat.statut === "En traitement"
                ? "bg-warning text-dark"
                : achat.statut === "Rejeté"
                ? "bg-danger text-white"
                : achat.statut === "Remboursé"
                ? "bg-success text-white"
                : "bg-secondary text-white"
            }`}
          >
            {achat.statut}
          </div>
        </td>
        <td
          className="text-center align-middle"
          style={{ padding: "0.5rem" }}
        >
          {(achat.statut === "Rejeté" || achat.statut === "rejete") && (
            <button
              onClick={(e) => {
                e.stopPropagation();
                setSelectedComment(achat.commentaire || "Aucun commentaire");
                setShowCommentModal(true);
              }}
              style={{
                borderRadius: "4px",
                width: "28px",
                height: "28px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
                transition: "all 0.2s",
                margin: "0 auto",
              }}
              className="btn btn-sm btn-gray action-button"
              aria-label="Voir commentaire"
            >
              <FaEye className="icon" />
            </button>
          )}
        </td>
      </tr>
    ))
  ) : (
    <tr>
      <td colSpan="8" className="text-center">
        Aucun achat trouvé
      </td>
    </tr>
  )}
</tbody>
                                        </table>
                                    </div>

                                    {/* Pagination Controls */}
                                    <div className="d-flex justify-content-between align-items-center mt-3">
                                        <div className="dataTables_info" role="status" aria-live="polite">
                                            {sortedAchats.length === 0
                                                ? "Aucun élément à afficher"
                                                : `Élément ${indexOfFirstAchat + 1} à ${Math.min(indexOfLastAchat, sortedAchats.length)} sur ${sortedAchats.length}`}
                                        </div>

                                        <div>
                                            {Array.from({ length: totalPages }, (_, index) => (
                                                <button
                                                    key={index + 1}
                                                    onClick={() => setCurrentPage(index + 1)}
                                                    className={`btn ${currentPage === index + 1 ? "btn-default" : "btn-light"
                                                        } mx-1`}
                                                >
                                                    {index + 1}
                                                </button>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* Modal de demande de remboursement */}
            <Modal show={showRemboursementModal} onHide={() => setShowRemboursementModal(false)}>
                <Modal.Header>
                    <Modal.Title>Demande de remboursement</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="form-group">
                        <label>Motif</label>
                        <textarea
                            className="form-control"
                            rows="3"
                            value={motifRemboursement}
                            onChange={(e) => setMotifRemboursement(e.target.value)}
                            placeholder="Veuillez indiquer le motif de la demande..."
                        ></textarea>
                    </div>
                    <div className="mt-2">
                        <small className="text-muted"> Achat de {selectedAchat?.quantite} {selectedAchat?.nom_produit} </small>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowRemboursementModal(false)}>
                        Annuler
                    </Button>
                    <Button variant="success" onClick={handleSubmitRemboursement}>
                        Soumettre
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Modal pour afficher le commentaire */}
            <Modal 
    show={showCommentModal} 
    onHide={() => setShowCommentModal(false)} 
    centered 
    size="md"
    backdrop="static"
    className="fade-scale"
>
    <Modal.Body className="p-4 text-center">
        {/* Icône animée */}
        <div className="mb-3 animate-bounce">
            <div className="icon-wrapper bg-danger bg-opacity-10 rounded-circle d-inline-flex p-3">
                <FaTimesCircle style={{ fontSize: "2.5rem", color: "#dc3545" }} />
            </div>
        </div>

        {/* Titre avec effet de gradient */}
        <h4 className="mb-4 fw-bold" style={{
            background: "linear-gradient(to right, #dc3545, #ff6b6b)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent"
        }}>
            Demande rejetée
        </h4>

        {/* Carte pour le commentaire */}
        <div className="mb-4 p-3 bg-light rounded" style={{
            borderLeft: "4px solid #dc3545",
            boxShadow: "0 2px 8px rgba(0,0,0,0.1)"
        }}>
            <div className="d-flex align-items-start">
                <FaQuoteLeft className="me-2 mt-1" style={{ color: "#dc3545", opacity: 0.5 }} />
                <p className="mb-0 text-dark" style={{ fontStyle: "italic" }}>
                    {selectedComment || "Aucun commentaire fourni"}
                </p>
            </div>
        </div>

        {/* Bouton avec animation au survol */}
        <Button 
            variant="outline-danger" 
            onClick={() => setShowCommentModal(false)}
            className="px-4 py-2 rounded-pill fw-medium"
            style={{
                transition: "all 0.3s ease",
                borderWidth: "2px"
            }}
        >
            Fermer
        </Button>
    </Modal.Body>
</Modal>

        </div>

    );
};

export default Liste_remboursement;